<template>
    <div>
        <v-select
            :taggable="allowAdd"
            :push-tags="allowAdd"
            label="name"
            :filterable="false"
            :options="clubOptions"
            @search="onSearch"
            :disabled="registrationCategoryId === '' && !noRegistrationCategory"
            v-model="selectedClub"
            :select-on-tab="true">
            <template slot="no-options">
                Search for a club
            </template>
        </v-select>
        <input type="hidden" name="club_name" id="club-name" v-model='selectedClubName'>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import _ from 'lodash';

export default {
    name: "club-select",
    components: {vSelect},
    props: {
        allowAdd: {
            type: Boolean,
            default: false,
        },
        registrationCategoryId: {
            type: Number | String,
            required: false,
        },
        defaultClubName: {
            type: String,
            required: false
        },
        value: {
            type: String,
            required: false,
            default: null,
        },
        noRegistrationCategory: { // used for series entries we don't have a registration category id
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            clubOptions: [],
            selectedClub: '', // note: could be a string or object
        }
    },
    mounted() {
        if (this.value != null) {
            this.selectedClub = this.value;
        }

    },
    computed: {
        selectedClubName() {
            if (typeof this.selectedClub == 'string') {
                return this.selectedClub;
            } else {
                return this.selectedClub !== null ? this.selectedClub.name : '';
            }
        },
    },
    watch: {
        selectedClub: function () {
            this.$emit('input', this.selectedClubName);
        }
    },
    methods: {
        onSearch(search, loading) {
            loading(true);
            this.search(loading, search, this);
        },
        search: _.debounce((loading, search, vm) => {

            let url = '/api/v0/clubs?name=' + search;

            if (!vm.noRegistrationCategory) {
                url += '&registration_category_id=' + vm.registrationCategoryId;
            }

            axios.get(url, {
                headers: {
                    'Accept': 'application/json'
                }
            }).then((response) => {
                vm.clubOptions = response.data.data;
                loading(false);
            });
        }, 350)
    }
}
</script>

<style>
/* Dropdown Menu */
.v-select.open > .dropdown-menu {
    display: block;

}

.v-select.open > .dropdown-menu, .dropdown-submenu .dropdown-menu {
    opacity: 1;
    visibility: visible;
    z-index: 1000;
    -moz-transform: none;
    -o-transform: none;
    -ms-transform: none;
    -webkit-transform: none;
    transform: none;
}


</style>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/ClubSelect.vue